// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateAuthorizeSetting_cancelButton__20rum","formItem":"UpdateAuthorizeSetting_formItem__3c7gR","buttonsContainer":"UpdateAuthorizeSetting_buttonsContainer__2EOAa"};